export default {
    "平台名称": "中亚西亚地区观测数据库平台",
    "平台介绍": "平台介绍",
    "数据集": "数据集",
    "合作单位": "合作单位",
    "联系我们": "联系我们",
    "返回首页": "返回首页",
    "首页": "首页",
    "元数据": "元数据",
    "样例": "样例",
    "详细情况": "详细情况",

    "管理编号": "管理编号",
    "产生方式": "产生方式",
    "空间范围": "空间范围",
    "时间范围": "时间范围",
    "学科分类": "学科分类",

    "数据内容描述": "数据内容描述",
    "关键词": "关键词",
    "数据信息": "数据信息",

    "数据量": "数据量",
    "数据记录数": "数据记录数",
    "更新版本": "更新版本",
    "数据生产者": "数据生产者",
    "请联系": "获取数据，请联系",

    "致谢": "致谢：中国科学院战略性先导科技项目“中亚西亚野外观测能力提升及数据库建设”支持（编号：XDA20020101）",
    "中心": "中国科学院中亚生态与环境研究中心",
    "中心2": "中亚生态与环境研究中心（杜尚别） ",
    "联系邮箱": "网站平台技术支持联系邮箱：lijin@ms.xjb.ac.cn"
}
